import gql from 'graphql-tag';

const UPDATE_REVOKED = gql`
  mutation Mutation($deviceSerialNo: String!, $revoked: Boolean!) {
    updateRevoked(deviceSerialNo: $deviceSerialNo, revoked: $revoked) {
      code
      billingApplicableFrom
    }
  }
`;

export default UPDATE_REVOKED;
